<template>
    <div class="d-flex align-items-center" v-if="!params.node.rowPinned">
        <b-button
            v-if="reservationEdit"
            variant="default"
            class="mr-2"
            @click="$bvModal.show(editModalId)"
            ><font-awesome-icon :icon="['fas', 'pen-to-square']"
        /></b-button>
        <b-button
            v-if="reservationDelete"
            variant="default"
            @click="$bvModal.show(deleteModalId)"
            ><font-awesome-icon :icon="['fas', 'trash']"
        /></b-button>
        <modal
            :id="deleteModalId"
            title="Delete Blocked Period"
            ok-title="Delete"
            @ok.prevent="deleteReservation"
        >
            Blocked period "{{ params.data.id }}" will be deleted. Are you sure?
        </modal>
        <modal
            :id="editModalId"
            title="Edit Blocked Period"
            ok-title="Save"
            @ok.prevent="editReservation"
        >
            <form-textarea v-model="notes" label="Notes" />
        </modal>
    </div>
</template>

<script>
import FormInput from '../../generic/form-input/form-input.vue';
import Modal from '../../generic/modal/modal.vue';
import { mapGetters } from 'vuex';
import responsiveButton from '../../generic/responsive-button/responsive-button.vue';
import formTextarea from '../../generic/form-textarea/form-textarea.vue';
export default {
    components: { responsiveButton, Modal, FormInput, formTextarea },
    data() {
        return {
            deleteModalId: null,
            editModalId: null,
            password: null,
            notes: null,
        };
    },
    mounted() {
        this.deleteModalId = 'deleteModalId' + this.params.data.id;
        this.editModalId = 'editModalId' + this.params.data.id;
        this.notes = this.params.data.notes;
    },
    computed: {
        ...mapGetters('reservationsStore', [
            'reservationDelete',
            'reservationEdit',
        ]),
    },
    methods: {
        deleteReservation() {
            if (this.params.deleteReservation) {
                this.params.deleteReservation(this.params.data.id);
            }
        },
        editReservation() {
            if (this.params.editReservation) {
                this.params.editReservation(this.params.data.id, this.notes);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.reservation-status-marker {
    border-radius: 50%;
    width: 20px;
    height: 20px;
}
</style>